import { NgModule } from '@angular/core';
import { DatePickerComponent } from './datepicker.component';
import { CommonModule } from '@angular/common';
import { IntlModule } from '@progress/kendo-angular-intl';
import { PopupModule } from '@progress/kendo-angular-popup';
import { CalendarModule } from '../calendar/calendar.module';
import { TemplatesModule } from '../calendar/templates.module';
import { DateInputModule } from '../dateinput/dateinput.module';
import { LocalizedMessagesDirective } from './localization/localized-messages.directive';
import { DatePickerCustomMessagesComponent } from './localization/datepicker-custom-messages.component';
import { TOUCH_ENABLED } from '../touch-enabled';
import { touchEnabled } from '../support';
var COMPONENT_DIRECTIVES = [
    DatePickerComponent,
    DatePickerCustomMessagesComponent,
    LocalizedMessagesDirective
];
var COMPONENT_MODULES = [
    DateInputModule,
    CalendarModule,
    IntlModule,
    PopupModule,
    TemplatesModule
];
/**
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the DatePicker component.
 */
var DatePickerModule = /** @class */ (function () {
    function DatePickerModule() {
    }
    DatePickerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [COMPONENT_DIRECTIVES],
                    exports: [COMPONENT_DIRECTIVES, TemplatesModule],
                    imports: [CommonModule].concat(COMPONENT_MODULES),
                    providers: [{ provide: TOUCH_ENABLED, useValue: touchEnabled }]
                },] },
    ];
    /** @nocollapse */
    DatePickerModule.ctorParameters = function () { return []; };
    return DatePickerModule;
}());
export { DatePickerModule };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dateinputs/dist/es/datepicker/datepicker.module.js
// module id = ../../../../@progress/kendo-angular-dateinputs/dist/es/datepicker/datepicker.module.js
// module chunks = vendor